import { context, trace } from '@opentelemetry/api';

export function startLightstepSpan(
  spanName: string,
  attributes?: Record<string, any>
) {
  const tracer = trace.getTracer('default');
  const span = tracer.startSpan(spanName, undefined, context.active());

  if (attributes) {
    Object.entries(attributes).forEach(([key, value]) => {
      span.setAttribute(key, value);
    });
  }

  return span;
}
